<template>
  <woot-modal :show.sync="show" :on-close="onClose" :size="modalSize">
    <woot-modal-header
      :header-title="$t('WHATSAPP_TEMPLATES.MODAL.TITLE')"
      :header-content="modalHeaderContent"
    />
    <div v-if="hasWhatsAppTemplates" class="row modal-content">
      <templates-picker
        v-if="!selectedWaTemplate"
        :whatsapp-template-messages="whatsappTemplateMessages"
        @onSelect="pickTemplate"
      />
      <template-parser
        v-else
        :template="selectedWaTemplate"
        @resetTemplate="onResetTemplate"
        @sendMessage="onSendMessage"
      />
    </div>
  </woot-modal>
</template>

<script>
import TemplatesPicker from './TemplatesPicker.vue';
import TemplateParser from './TemplateParser.vue';
export default {
  components: {
    TemplatesPicker,
    TemplateParser,
  },
  props: {
    inboxId: {
      type: Number,
      default: undefined,
    },
    show: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      selectedWaTemplate: null,
    };
  },
  computed: {
    whatsappTemplateMessages() {
      // getWhatsAppTemplates ya filtra las plantillas aprobadas por Meta y los formatos de media no
      // soportados; se reusa directamente para evitar doble filtrado (mismo patrón que
      // MessengerTemplates/Modal).
      return this.$store.getters['inboxes/getWhatsAppTemplates'](this.inboxId);
    },
    hasWhatsAppTemplates() {
      return this.whatsappTemplateMessages.length > 0;
    },
    // Devuelve el tamaño del modal según si hay plantillas de WhatsApp disponibles o no.
    modalSize() {
      return this.hasWhatsAppTemplates ? 'modal-big' : 'modal-medium';
    },
    modalHeaderContent() {
      if (this.selectedWaTemplate) {
        return this.$t('WHATSAPP_TEMPLATES.MODAL.TEMPLATE_SELECTED_SUBTITLE', {
          templateName: this.selectedWaTemplate.name,
        });
      }
      if (this.hasWhatsAppTemplates) {
        return this.$t('WHATSAPP_TEMPLATES.MODAL.SUBTITLE');
      }
      return this.$t('WHATSAPP_TEMPLATES.MODAL.NO_TEMPLATES_SUBTITLE');
    },
  },
  methods: {
    pickTemplate(template) {
      this.selectedWaTemplate = template;
    },
    onResetTemplate() {
      this.selectedWaTemplate = null;
    },
    onSendMessage(message) {
      this.$emit('on-send', message);
    },
    onClose() {
      this.$emit('cancel');
    },
  },
};
</script>

<style scoped>
.modal-content {
  padding: 2.5rem 3.2rem;
}
</style>
